import { Pipe, PipeTransform } from '@angular/core';

import { IProject } from 'src/modules/shared/models/project.model';

@Pipe({
    name: 'filterProjects',
    standalone: false
})
export class FilterProjectsPipe implements PipeTransform {

  static filter(items: IProject[], term: string, excludes: any): IProject[] {

    const toCompare = term.toLowerCase();

    // tslint:disable-next-line: no-shadowed-variable
    function checkInside(item: any, term: string) {
      if (typeof item === 'string' && item.toString().toLowerCase().includes(toCompare)) {
        return true;
      }

      // tslint:disable-next-line: prefer-const
      for (let property in item) {
        if (item[property] === null || item[property] === undefined || excludes.includes(property)) {
          continue;
        }
        if (typeof item[property] === 'object') {
          if (checkInside(item[property], term)) {
            return true;
          }
        } else if (item[property].toString().toLowerCase().includes(toCompare)) {
          return true;
        }
      }
      return false;
    }

    return items.filter((item) => {
      return checkInside(item, term);
    });
  }

  transform(items: IProject[], term: string, excludes: any = []): IProject[] {
    if (!term || !items) {
      return items;
    }

    return FilterProjectsPipe.filter(items, term, excludes);
  }
}
